import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Location = {
  hash: string;
  key: string;
  pathname: string;
  search: string;
};
type State = {
  pastLocations: any[];
  previousLocation: Location | null;
};

const initialState: State = {
  pastLocations: [],
  previousLocation: null,
};

const appSlice = createSlice({
  name: 'action',
  initialState: initialState,
  reducers: {
    setPastLocations: (state: State, action: PayloadAction<Location[]>) => {
      state.pastLocations = action.payload;
    },
    setPreviousLocation: (
      state: State,
      action: PayloadAction<Location | null>
    ) => {
      state.previousLocation = action.payload;
    },
  },
});

export const { setPastLocations, setPreviousLocation } = appSlice.actions;
export default appSlice.reducer;
